///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { forEach, groupBy } from "lodash";

import { round } from "./laneCalculations";

const mapCpmFrequencyGraphDetails = loads => {
  const data = [];
  if (loads && loads.length) {
    forEach(
      groupBy(loads, l => round(l.cost / l.miles)),
      (value, key) =>
        data.push({
          averageCpm: parseFloat(key),
          volume: value.length,
          averageCost: round(value.reduce((acc, l) => acc + l.cost, 0) / value.length)
        })
    );
  }
  return data;
};

export default mapCpmFrequencyGraphDetails;
